import {
  Campaign,
  Event,
  ContactPhone,
  PersonOutline,
  SupportAgent,
  Info,
  Hotel,
  AppRegistration,
  Description,
} from '@mui/icons-material';

/**
 * Map notification category / related entity to icon + label for inbox UI.
 */
export function getNotificationCategoryMeta(item = {}) {
  const category = String(item.category || '').toLowerCase();
  const entity = String(item.relatedEntityType || '').toLowerCase();
  const haystack = `${category} ${entity}`;

  if (haystack.includes('support')) {
    return { icon: SupportAgent, color: 'secondary.main', label: 'Customer Support', filter: 'support' };
  }

  if (haystack.includes('accommodation') || haystack.includes('accomodation')) {
    return { icon: Hotel, color: 'info.main', label: 'Accommodation', filter: 'accommodation' };
  }

  const customerRegistration =
    category.includes('customerregistration') ||
    category.includes('customer_registration') ||
    (category.includes('customer') &&
      (category.includes('registration') ||
        category.includes('register') ||
        category.includes('signup')) &&
      !category.includes('support') &&
      !category.includes('contact'));

  if (
    customerRegistration ||
    (entity === 'customer' && (category.includes('registration') || category.includes('register')))
  ) {
    return { icon: AppRegistration, color: 'secondary.dark', label: 'Customer registration', filter: 'customer_registration' };
  }

  if (
    category.includes('documentation') ||
    category.includes('document') ||
    entity === 'document' ||
    entity === 'documents'
  ) {
    return { icon: Description, color: 'grey.700', label: 'Documentation', filter: 'documentation' };
  }

  if (category.includes('promotion')) {
    return { icon: Campaign, color: 'warning.main', label: 'Promotion', filter: 'promotion' };
  }
  if (category.includes('event')) {
    return { icon: Event, color: 'success.main', label: 'Events', filter: 'event' };
  }
  if (category.includes('contact')) {
    return { icon: ContactPhone, color: 'info.main', label: 'Contact', filter: 'contact' };
  }
  if (category.includes('user')) {
    return { icon: PersonOutline, color: 'primary.main', label: 'User', filter: 'user' };
  }

  return { icon: Info, color: 'grey.700', label: 'General', filter: 'all' };
}
